import { Box, Button, Grid, IconButton, InputBase, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import SearchIcon from "@mui/icons-material/Search";
import Popup from '../Popup';
import createInstance from '../../../api/axiosinstance';
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";


const CandidatesHiredRejected = ({value}) => {

  const [candidateId, setCandidateId] = useState("");
  const [candidateName, setCandidateName] = useState("");
  const [appliedPosition, setAppliedPosition] = useState("");
  const [interviewDate, setInterviewDate] = useState(null);
  const [questionsAnswered, setQuestionsAnswered] = useState(0);
  const [skillsPercentage, setSkillsPercentage] = useState("");
  const [analyticalPercentage, setAnalyticalPercentage] = useState("");
  const [teamPlayerPercentage, setTeamPlayerPercentage] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [candidatesList, setCandidatesList] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const dateHeader = value +" date";
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const aiDishaApi = createInstance("DISHA");
  const { COLORS } = useThemeMode();
  

  const [formData, setFormData] = useState({
    candidate_id: "",
    candidate_full_name: "",
    email_id: "",
    job_title: "",
    skills: "",
    educational_qualification: "",
    experience : ""
  });

  //const organizationId = "ORGID000002";
  const organizationId = window.sessionStorage.getItem("organizationId");
  console.log("ORGID"+organizationId);
  

  useEffect(()=>{
    if(value === "Hired"){
      getAllHiredCandidates();
    }else if (value === "Rejected"){
      getAllRejectedCandidates();
    }
    
   
  },[]) ;

  const getAllHiredCandidates = async () => {
    await aiDishaApi.get(`/candidates-hired?org_id=${organizationId}`)
    .then((response)=>{
      setCandidatesList(response.data["candidates Hired"])
      console.log("hired candidates ", response.data);
  })
    .catch((error)=>(
      console.log("Error fetching the hired candidates list"+error)
    ));

  }

  const getAllRejectedCandidates = async () => {
    await aiDishaApi.get(`/candidates-rejected?org_id=${organizationId}`)
    .then((response)=>(
      setCandidatesList(response.data["candidates_rejected"])
    ))
    .catch((error)=>(
      console.log("Error fetching the rejected candidates list"+error)
    ));

  }

  const handleViewCandidate = async (candidateId) =>{
    setOpenPopup(true);
    let candidate = {};
    await aiDishaApi.get(`/get-candidates-by-candidate-id?candidate_id=${candidateId}`)
    .then((response)=>{
      candidate = response.data;
      console.log(candidate)
      setFormData({
        ...formData,
        candidate_id: candidate.candidate_id,
        candidate_full_name: candidate.candidate_full_name,
        email_id: candidate.email_id,
        job_title: candidate.job_title,
        skills: candidate.skills || "",
        educational_qualification: candidate.educational_qualification,
        experience : candidate.experience
      }
      )
    })
    .catch((error)=>{
      console.log("Error fetching candidate details "+ error);
    })
  }

  // const getSelectedCandidateDetails = () =>{

  // }

  const handlePopupClose = () =>{
    setOpenPopup(false);
  }
  // Pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  //Search jobs based on Job Title
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
};

  const status = value;
  const tableHeader = [{    
    id: "Candidate ID",
    name : "Candidate Name",
    title: "Job Title",
    location: "Job Location",
    date: dateHeader,
    interviewer: "Interviewed By",
    status: "Status",
    action: "Action"}];
  
    const filteredCandidates = candidatesList.filter((row) => 
      row.candidate_full_name?.toLowerCase().includes(searchTerm.toLowerCase()) 
    );

  return (
    <div>
    <div>
      <div>
        <Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          sx={{
              marginTop: "auto",alignItems: "center",borderRadius: "10px",
              padding: "1% 1%",}}  >
          <Box gridColumn="span 12" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "5%" }}>
            <Typography sx={{ fontFamily: "poppins", fontSize: "28px", color: COLORS.text }}>
                {value === "Hired" ? "Candidates Hired" : "Candidates Rejected"}
            </Typography>
          </Box>

          <Box gridColumn="span 6"
            sx={{ marginTop:"auto", textAlign:"left", marginBottom:"2%" , marginLeft:"8%"}}>
              <Paper sx={{
                      p: "2px 4px",display: "flex",width: "75%",
                      borderRadius: 2, background: COLORS.primary,
                  }} > 
                <IconButton type="button" sx={{ p: "8px", color: COLORS.text }}
                    aria-label="search">
                    <SearchIcon /></IconButton>
                <InputBase
                    sx={{ ml: 1, flex: 1, 
                      fontFamily: "Poppins", 
                      color: COLORS.text,
                      "& input::placeholder": {
                             color: `${COLORS.text} !important`, // 👈 placeholder color
                             opacity: 10, // important (MUI reduces opacity by default)
                           },
                     }} // Set text color to white
                    placeholder="Search by Candidate Name"
                    inputProps={{ "aria-label": "search google maps" }}
                    value={searchTerm} onChange={handleSearch} 
                    />
              </Paper>   
          </Box>
        </Box>

        <Box xs={1} sx={{ backgroundColor: "#33333" }}>
          <Grid container spacing={1} sx={{ justifyContent: "center" }}>
            <Grid item xs={11}>
              <TableContainer component={Paper}
                        sx={{marginTop: "25px",borderRadius: "10px",}}>                       
                <Table size="small">
                  <TableHead sx={{ background: COLORS.primary }}>
                    {tableHeader.map((header) => (
                      <TableRow key={header.id}>
                        <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                          {header.id}</TableCell>
                        <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                          {header.name} </TableCell>                                   
                        <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                          {header.title}</TableCell>
                        <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                          {header.location}</TableCell>      
                        <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                          {header.date} </TableCell>
                        <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                          {header.interviewer} </TableCell>
                        <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                          {header.action}</TableCell>
                      </TableRow>
                    ))}
                  </TableHead>      
                  <TableBody>
                    {filteredCandidates && filteredCandidates
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((n, index) => (
                        <TableRow
                            key={n.candidate_id}
                            sx={{ background: COLORS.background, marginRight: "30px" }}>
                          <TableCell sx={{ color: COLORS.text, border: COLORS.secondary }}>
                            {n.candidate_id} </TableCell>
                          <TableCell sx={{ color: COLORS.text, border: COLORS.secondary }}>
                            {n.candidate_full_name}</TableCell>
                          <TableCell sx={{ color: COLORS.text, border: COLORS.secondary }}>
                            {n.job_title} </TableCell>
                          <TableCell sx={{ color: COLORS.text, border: COLORS.secondary }}>
                            {n.job_location} </TableCell>
                          <TableCell sx={{ color: COLORS.text, border: COLORS.secondary }}>
                            {value === "Hired" ? n.hired_date : n.rejected_date}</TableCell>
                          <TableCell sx={{ color: COLORS.text, border: COLORS.secondary }}>
                            {n.interviewer_name}</TableCell>
                          <TableCell sx={{border: COLORS.secondary ,color: "#A7A7A7",
                                          display: "flex",alignItems: "center",}}>
                            
                            <Button variant="contained"
                              sx={{
                              background: COLORS.button_edit_bg,
                                  "&:hover": {
                                    background: COLORS.hover_edit_btn,
                                  },
                                  color: COLORS.background,
                              marginRight: "10px",
                              fontFamily: "poppins",
                              height: "30px",width: "40px",}}
                              onClick={()=>handleViewCandidate(n.candidate_id)}>
                                View </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 15]} component="div"
                    count={filteredCandidates.length} rowsPerPage={rowsPerPage}
                    page={page} onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    sx={{background: COLORS.primary,color: COLORS.text,}}/>
              </TableContainer>
            </Grid>
          </Grid>
        </Box>

        <Popup
          title = "View Candidate"
          openPopupVar = {openPopup}
          setOpenPopupMet = {setOpenPopup}>
          <div className="modal-content" style={{ background: COLORS.primary }}>
            <div className="modal-header border-0">
              <label style={{color:COLORS.text,fontSize:"18px"}}>View Candidate</label>
              <button type="button" className="btn-close" onClick={handlePopupClose}></button>
            </div>
                
          
            {/*First Row*/}
            <div className="row" style={{ margin: "0% 2%" }}>
              <div className="col-sm-4">
                <label className="aa" htmlFor="candidateId"
                  style={{fontFamily: "Poppins",fontSize: "12px",color: COLORS.text,}}>
                  Candidate ID{" "}</label>
                <input type="text" name="candidateId" className="form-control form-control-sm"
                  value={formData.candidate_id} readOnly
                  style={{border: "none",width: "100%",fontFamily: "Poppins",fontSize: "12px",
                    color: COLORS.text, background: COLORS.background}} />
                </div>
              <div className="col-sm-4">
                <label className="aa" htmlFor="candidateName"
                  style={{fontFamily: "Poppins", fontSize: "12px", color: COLORS.text, }}>
                  Candidate Full Name{" "}</label>
                <input type="text" name="candidateName" className="form-control form-control-sm"
                  value={formData.candidate_full_name}
                  style={{backgroundColor: "#1E1E1E", border: "none", width: "100%", 
                    fontFamily: "Poppins", fontSize: "12px", color: COLORS.text, background: COLORS.background}} readOnly />
                </div>
              <div className="col-sm-4">
                <label className="aa" htmlFor="email"
                  style={{fontFamily: "Poppins", fontSize: "12px", color: COLORS.text, }}>
                  Email ID{" "}</label>
                <input type="text" name="email" className="form-control form-control-sm"
                  readOnly value={formData.email_id}
                  style={{border: "none", width: "100%", fontFamily: "Poppins", fontSize: "12px",
                    color: COLORS.text, background: COLORS.background}}/>
                </div>
              </div>

              {/*Second Row*/}
              <div className="row" style={{ margin: "0% 2%" }}>
                <div className="col-sm-4">
                  <label className="aa" htmlFor="jobTitle"
                    style={{fontFamily: "Poppins", fontSize: "12px", color: COLORS.text,}}>
                    Job Title{" "}</label>
                  <input type="text" name="jobTitle" className="form-control form-control-sm"
                  readOnly value={formData.job_title}
                    style={{border: "none", width: "100%", fontFamily: "Poppins", fontSize: "12px",
                      color: COLORS.text, background: COLORS.background}} />
                  </div>
                <div className="col-sm-4">
                  <label className="aa" htmlFor="qualification"
                    style={{fontFamily: "Poppins", fontSize: "12px", color: COLORS.text, }} >
                    Qualification{" "}</label>
                  <input type="text" name="qualification" readOnly className="form-control form-control-sm"
                    value={formData.educational_qualification}
                    style={{border: "none", width: "100%", fontFamily: "Poppins", fontSize: "12px",
                      color: COLORS.text, background: COLORS.background}} />
                  </div>
                <div className="col-sm-4">
                  <label className="aa" htmlFor="skills" 
                    style={{fontFamily: "Poppins", fontSize: "12px", color: COLORS.text, }} >
                    Skills{" "}</label>
                  <input type="text" name="skills" className="form-control form-control-sm"
                    readOnly value={formData.skills}
                    aria-label="Job ID" 
                    style={{
                      border: "none",width: "100%", fontFamily: "Poppins", fontSize: "12px",
                      color: COLORS.text, background: COLORS.background}} />
                  </div>
                </div>

                {/*Third Row*/}
                <div className="row" style={{ margin: "0% 2%" }}>
                  <div className="col-sm-4">
                    <label className="aa" htmlFor="experienceYears"
                      style={{fontFamily: "Poppins", fontSize: "12px", color: COLORS.text,}}>
                      Experience{" "}</label>
                    <input type="text" name="experienceYears" className="form-control form-control-sm"
                    value={formData.experience} readOnly
                      style={{border: "none", width: "100%", fontFamily: "Poppins", fontSize: "12px",
                        color: COLORS.text, background: COLORS.background}} />
                    </div>
                  </div>
                  <br/><br/>
          </div>
        </Popup>
      </div>
    </div> 

    </div>
  )
}

export default CandidatesHiredRejected;